module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-bottom": "15px"
    }
  }, [_vm._v("W.L. Burke was born, raised and resides in the rocky mountains. He has been living there for the last 30 years, on a small ranch, raising children, horses, dogs, and various sundry types of animals. Some of those were sold, some were raced, some were rescued, and some are kept around as family.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-bottom": "15px"
    }
  }, [_vm._v("One of five children, the author quit school at 15 and went to work full time, but recommends this option to no one. A life-long love of reading overcame this shortfall, gaining a diploma and taking some college courses, which, prompted some writing attempts.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0